// extracted by mini-css-extract-plugin
module.exports = {"item":"recommandation_item__A1vNy"};